import React, { useState } from 'react';
import Paper from '@mui/material/Paper';
import MuiTable from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableRow from '@mui/material/TableRow';
import PaginationRow from '@components/PaginationRow';
import usePagination from '@core/hooks/usePagination';
import useGetReferrersStatistics from '../../hooks/useGetReferrerStatistics';
import Filters from './Filters';
import ReferrerStatisticRow from './ReferrerStatisticRow';
import TableHead from './TableHead';
import useSx from './sx';

type Props = {
  startDate: Date;
  endDate: Date;
  startDateFormattedParam: string;
  endDateFormattedParam: string;
};

const Referrers = ({ startDate, endDate }: Props) => {
  const sx = useSx();
  const { pageSize, currentPage, changePage, changePageSize } = usePagination<any>(10);
  const [order, setOrder] = useState('ASC');
  const [customFilters, setCustomFilters] = useState<Record<string, number | string | undefined>>({
    selectedIdentityId: undefined,
    selectedBranchId: undefined,
    selectedModalityId: undefined,
  });

  const filters = {
    startDate,
    endDate,
    pageSize,
    pageNumber: currentPage,
    sortOrder: order,
    selectedIdentityId: customFilters.selectedIdentityId as string,
    branchId: customFilters?.selectedBranchId as number,
    modalityId: customFilters?.selectedModalityId as number,
  };

  const { referrersStatistics } = useGetReferrersStatistics(filters);
  
  const isGroupSelected = customFilters.selectedIdentityId?.toString().startsWith('group:');
  const noReferrersToShow = referrersStatistics?.result?.items?.length === 0;

  return (
    <>
      <Filters
        onFiltersChange={(newFilters) => {
          setCustomFilters(newFilters);
        }}
      />
      <TableContainer sx={sx.tableContainer} component={Paper}>
        <MuiTable className="table" aria-label="simple table">
          <TableHead onOrderChange={setOrder} />
          <TableBody>
            {(referrersStatistics?.result?.items?.length ?? 0) > 0 ? (
              referrersStatistics?.result?.items?.map((entity) => (
                <ReferrerStatisticRow key={entity.entityId} entity={entity} />
              ))
            ) : isGroupSelected && noReferrersToShow ? (
              <TableRow>
                <TableCell colSpan={8} sx={{ textAlign: 'center', padding: '20px' }}>
                  No se encontraron médicos para este grupo
                </TableCell>
              </TableRow>
            ) : null}
            <PaginationRow
              onChangePageSize={changePageSize}
              pageSizeRange={[5, 10, 30, 50]}
              pageCount={referrersStatistics?.result?.pageCount ?? 0}
              onPageChange={changePage}
              currentPage={currentPage}
              totalCount={referrersStatistics?.result?.totalCount ?? 0}
              pageSize={pageSize}
            />
          </TableBody>
        </MuiTable>
      </TableContainer>
    </>
  );
};

export default Referrers;
